import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FiltersForm } from '../components/FiltersForm';
import { SvgHistogram } from '../components/SvgHistogram';
import { Table } from '../components/Table';
import { DownloadMenu } from '../components/DownloadMenu';
import { Section } from '../components/Section';
import { distributionSchema } from '../validation';
import { useKpiDistribution, useQueryParams } from '../hooks/useKpi';
import type { DistributionParams } from '../types';

const defaults = { collection: '', field: '', bins: 10 } as const;

export default function Distribution() {
  const [search] = useSearchParams();
  const merged = useQueryParams({ collection: '', field: '', bins: 10 }, search);
  const mergedTyped = merged as unknown as DistributionParams;
  const [params, setParams] = useState<DistributionParams | undefined>(mergedTyped.collection ? mergedTyped : undefined);
  const query = useKpiDistribution(params);

  return (
    <Section title="Distribución" description="Histogramas simples por campo">
      <FiltersForm defaultValues={mergedTyped} schema={distributionSchema as any} fields={[{ name: 'collection', label: 'Colección' }, { name: 'field', label: 'Campo' }, { name: 'bins', label: 'Bins', type: 'number' }]} onSubmit={(values) => setParams(values)} />
      {query.isLoading && <p>Cargando...</p>}
      {query.error && <p className="text-red-600">Error al cargar</p>}
      {query.data && <div className="space-y-4"><SvgHistogram data={query.data.map((d) => ({ label: d.label, value: d.value }))} /><DownloadMenu filename="distribution" rows={query.data as any} /><Table rows={query.data as any} /></div>}
    </Section>
  );
}
